import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { OzonScreenTabs } from './OzonScreenTabs'
import { OzonLoadOrdersForm } from './OzonLoadOrdersForm'
import { OrdersTableTab, StoreOrdersScreen } from './StoreOrdersScreen'

import { useLogic, useStore } from '../hooks/storeHook'

import { OzonAccountProps } from '../types/accountProps'
import { ozonOrderColumns } from '../types/ozonOrderColumns'
import { OzonDeliveryType } from '../server/mpsklad_core/Entity/Ozon/OzonDeliveryType'

export const OzonOrdersTabsScreen = () =>
  <OzonScreenTabs ScreenComponent={OzonOrdersScreen}/>

export const OzonOrdersScreen =
  observer(
    ({account}: OzonAccountProps) => {
      const {api, ozonOrderLoaders} = useLogic()
      const {orderStore: {createOzonOrdersTable}} = useStore()

      const ozonOrders = useMemo(
        () => createOzonOrdersTable(account.id),
        [createOzonOrdersTable, account])

      useEffect(() => ozonOrderLoaders.addHandler(ozonOrders.load), [ozonOrderLoaders, ozonOrders])

      const tabs = useMemo(() => {
          const commonTabs =
            [OrdersTableTab.Active, OrdersTableTab.Cancelled, OrdersTableTab.WithErrors] as const

          return account.deliveryType === OzonDeliveryType.FBO
                 ? [...commonTabs, OrdersTableTab.LoadOrders] as const
                 : commonTabs
        },
        [account.deliveryType])

      return (
        <StoreOrdersScreen
          account={account}
          tabValues={tabs}
          orders={ozonOrders}
          columns={ozonOrderColumns}
          searchPlaceholder="Id / Id в Ozon / Номер отправления / Артикул товара"
          pullOrdersWithErrors={api.order.pullOzonOrdersWithErrors}
          exportOrdersToExcel={api.order.exportOzonToExcel}
          LoadOrdersFormComponent={OzonLoadOrdersForm}
        />
      )
    })